import { getExpires, getId } from '@ga/utils'

import {
  DEVICE_ID_COOKIES_KEY,
  SUPPORT_MESSENGERS_ICONS,
  WEBVIEW_COOKIES_KEY,
} from '../constant'

export class MainService {
  constructor(gaApp) {
    this.gaApp = gaApp
  }

  get commonState() {
    return this.gaApp.stores.app.common
  }

  get isSSR() {
    return this.gaApp.stores.app.main.isSSR
  }

  /** Достаем deviceId из сторы */
  get deviceId() {
    return this.gaApp.stores.app.main.deviceId
  }

  get supportMessengers() {
    return Object.fromEntries(
      Object.entries(this.commonState.messengers).map(([key, value]) => {
        const icon =
          SUPPORT_MESSENGERS_ICONS[key] ?? SUPPORT_MESSENGERS_ICONS.default

        return [key, { ...value, icon }]
      }),
    )
  }

  get supportMessengerDefault() {
    return Object.values(this.supportMessengers).find(
      (messenger) => messenger.isDefault,
    )
  }

  get suggestCities() {}

  get baseUrl() {
    return this.commonState.baseUrl || this.gaApp.stores.app.main.baseUrl || ''
  }

  get currentStoreContent() {
    const { country } = this.gaApp.i18n.locale.value

    return this.getStoreContent(country)
  }

  // записываем в куки и локалстору, что был заход с вебвью параметром
  // включаем флаг в сторе
  initWebview() {
    this.gaApp.stores.app.main.webview = true

    this.gaApp.cookies.set(WEBVIEW_COOKIES_KEY, 1, {
      expires: getExpires(31536000),
      path: '/',
      sameSite: 'lax',
    })

    this.gaApp.services.app.browserStorage.local.set(WEBVIEW_COOKIES_KEY, 1)
  }

  // очищаем куки и локалстору от флага означающего заход с вебвью
  clearWebview() {
    this.gaApp.cookies.remove(WEBVIEW_COOKIES_KEY)
    this.gaApp.services.app.browserStorage.local.remove(WEBVIEW_COOKIES_KEY)
  }

  getStoreContent(country) {
    return this.commonState.stores.find((store) => store.code === country)
  }

  setSSR() {
    this.gaApp.stores.app.main.isSSR = true
  }

  /*
   * Проверяет является ли пользователь ботом.
   */
  checkBot() {
    const isBot = Boolean(this.gaApp.serverRequest.headers['x-customer-is-bot'])

    if (isBot) {
      this.gaApp.stores.main.user.isBot = true
    }
  }

  /**
   * Отдает страницу ошибки
   */
  checkCriticalError() {
    const criticalError = this.gaApp.serverRequest.headers['x-critical-error']

    if (criticalError) {
      throw new Error('Ошибка')
    }
  }

  getMainCity() {
    return this.commonState.mainCity
  }

  getRouter() {
    return this.gaApp.stores.app.main.router
  }

  /** Заполняем в стору deviceId из кук */
  fillDeviceId(parentDeviceId) {
    let deviceId = parentDeviceId

    // если dev режим и нет device id, генерим и заполняем куку
    if (this.gaApp.config.get('dev') && !deviceId) {
      deviceId = getId()
      const expiresDate = new Date()
      expiresDate.setFullYear(expiresDate.getFullYear() + 1)

      this.gaApp.cookies.set(DEVICE_ID_COOKIES_KEY, deviceId, {
        expires: expiresDate,
        path: '/',
        sameSite: 'lax',
      })
    }

    this.gaApp.stores.app.main.deviceId = deviceId
    this.gaApp.services.app.apm.addLabels({ deviceId })
  }

  processGetParams() {
    // TODO: дополнить
  }

  /** Обработка информации о текущей витрине */
  // TODO: отказаться от хардкода plaid заголовков в пользу данных от магазина?
  processAppInfo(data) {
    const { debug, deviceId, baseUrl } = data

    this.setDebug(debug)
    this.setBaseUrl(baseUrl)
    this.fillDeviceId(deviceId)
  }

  /** Сохранение значения дебаг-режима */
  setDebug(isDebug) {
    this.gaApp.stores.app.main.isDebug = isDebug
  }

  /** Сохранение значения baseUrl */
  setBaseUrl(baseUrl) {
    this.gaApp.stores.app.main.baseUrl = baseUrl
  }
}
